import React from 'react';
import { Flex, Heading, Button } from 'rebass';
import Field from 'components/Field';

interface InterviewProcessProps {
  values: any;
  handleSubmit: any;
  hasValidationErrors: boolean;
  setNextFormStepHandler: any;
  setPreviousFormStepHandler: any;
}

const InterviewProcess: React.FC<InterviewProcessProps> = (props): JSX.Element => {
  const {
    handleSubmit,
    hasValidationErrors,
    setNextFormStepHandler,
    setPreviousFormStepHandler,
  } = props;

  return (
    <Flex flexDirection="column" alignItems="center" py={7}>
      <Heading fontSize={['20px']} fontWeight={6} mb={5}>
        Tell us about your interview process.
      </Heading>
      <Field
        name="interviewsCount"
        label="How many interviews will be conducted?"
        placeholder="Enter a number"
        numberInputMin={0}
        inputType="number"
        required
      />
      <Field
        name="isRequireRecruiter"
        label="Do you require the recruiter to administer a technical test?"
        inputType="select"
        selectOptions={['yes', 'no']}
        required
      />
      <Field
        name="linkToTest"
        label="If yes, please provide a link to the technical test:"
        placeholder="Enter URL here"
        inputType="text"
      />
      <Flex width="100%" justifyContent="space-between" mt={2} css="max-width: 550px;">
        <Button variant="primary" onClick={setPreviousFormStepHandler}>
          Back
        </Button>
        <Button
          variant="primary"
          onClick={hasValidationErrors ? handleSubmit : setNextFormStepHandler}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
};

export default InterviewProcess;
